import React, { useState } from "react";
import Modal from "./ui/Modal";
import { Eye, XCircle } from "lucide-react";
import { CloseCircle, EyeSlash } from "iconsax-react";
import { ClipLoader } from "react-spinners";
import { tokenService } from "../lib/service";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");

  const HandleClose = () => {
    setOpen(false);
  };
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  async function login(e) {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        // "https://dagi-production-2ae3.up.railway.app/api/login",
        // "http://localhost:3000/api/login",
        "https://api.dagifeed.com/api/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
            password: password,
          }),
        }
      );

      const data = await response.json();
      console.log(data)

      if (!response.ok) {
        setMessage(data?.error ? data?.error :"Login Failed");
        setStatus("error");
        setIsLoading(false);
      } else {
        if(data?.user?.role !== "customer"){
            setMessage("Unautorized Role");
            setStatus("error");
            setIsLoading(false);   
        }else {
            setMessage("Login Successful");
            setStatus("good"); // You can save token, redirect user, etc.
            setIsLoading(false);
            tokenService?.setToken(data?.token);
            setTimeout(() => {
                navigate("/customer");
      
            }, 2000);
        }
       
      }

  

    } catch (error) {
      setMessage(error?.error ? error?.error : "Login Failed");
      setStatus("error");
      setIsLoading(false);
    }
  }

  return (
    <div>
      <section className="bg-gradient-to-r from-green-50 to-orange-50 py-20">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold text-green-700 mb-4">
                Nourishing <span className="text-orange-500">Growth</span>{" "}
                Through Quality Feed
              </h1>
              <p className="text-lg text-gray-700 mb-8">
                De Ashymai Global Investment Limited (DAGI) is a leading
                manufacturer of professional poultry feed products and provider
                of animal nutrition services.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="#about"
                  className="bg-orange-500 text-white px-6 py-3 rounded-md hover:bg-orange-600 transition text-center"
                >
                  Learn More
                </a>
                <button
                  onClick={() => setOpen(true)}
                  className="bg-green-600 text-white px-6 py-3 rounded-md hover:bg-green-700 transition text-center"
                >
                  Login
                </button>
              </div>
            </div>
            <div className="md:w-1/2">
              <img
                src="./poultryFeed.jpg"
                alt="Poultry Feed Products"
                className="rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      <Modal isOpen={open} onClose={HandleClose}>
      <div className="inline-block relative bg-[white] mt-10  p-[18px] md:p-[24px] xl:p-[32px] rounded-[18px] md:rounded-[20px] lg:rounded-[24px] overflow-hidden text-left align-bottom transition-all transform   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[450px] md:max-w-[550px]">

          <div className="mt-4 flex justify-between mx-5">
            <h3 className="text-[18px] md:text-[20px]  text-[#1A202C] font-semibold"></h3>
            <XCircle
              size={16}
              className="cursor-pointer"
              onClick={HandleClose}
            />
          </div>

          <img
            src="./dagiLogo.png"
            alt="logo"
            className=" h-[40px] md:h-[50px]  mx-auto  mb-[18px] md:mb-[25px]"
          />

          {message && (
            <div
              className={`${
                status === "good" ? "bg-green-500" : "bg-red-500"
              } px-4 py-2 bg-opacity-30 mx-auto rounded-lg`}
            >
              <p
                className={`${
                  status === "good" ? "text-green-500" : "text-red-500"
                } text-[13px] text-center`}
              >
                {message}
              </p>
            </div>
          )}

          <p className="text-[16px] md:text-[20pxpx] xl:text-[24px]  font-normal leading-[24px] text-[#1C1C1C]  mt-[18px] md:mt-[25px] ">
            Sign in
          </p>
          <p className="text-[14px] md:text-[14px] xl:text-[16px]  font-light  text-[#1C1C1C] ">
            Welcome Onboard! let get started
          </p>
          <form onSubmit={login} className="mt-[10px] md:mt-[20px] ">
            <div className="mb-[16px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-light  text-[#1C1C1C] mb-[8px]">
                Username
              </label>
              <div className=" relative    flex items-center">
                <CloseCircle
                  size="16"
                  color="#98A2B3"
                  className="absolute right-[16px]"
                />

                <input
                  type="email"
                  placeholder="Enter username"
                  className="w-full h-[48px] pl-[16px] py-[12px] text-[14px] text-[#9C9C9C] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D0D5DD] border-[0.2px] rounded-[8px] focus:outline-none focus:ring-[#1254bd] focus:border-[#1254bd] "
                  // required
                  autoComplete="on"
                  name="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
              </div>
            </div>
            <div className="mb-[10px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-light leading-[24px] text-[#1C1C1C] mb-[8px]">
                Password
              </label>
              <div className=" relative    flex items-center">
                <div className="absolute right-[16px]">
                  {isOpen === false ? (
                    <Eye size="16" color="#98A2B3" onClick={toggle} />
                  ) : (
                    <EyeSlash size="16" color="#98A2B3" onClick={toggle} />
                  )}
                </div>
                <input
                  type={isOpen === false ? "password" : "text"}
                  placeholder="Enter password"
                  className="w-full h-[48px] pl-[16px] py-[12px] text-[14px] text-[#9C9C9C] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D0D5DD] border-[0.2px] rounded-[8px] focus:outline-none focus:ring-[#1254bd] focus:border-[#1254bd] "
                  // required
                  autoComplete="on"
                  name="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
              </div>
            </div>
            <div className="flex gap-1 mb-8 items-center">
              <input type="checkbox" className="" />
              <p className="font-light">Remember me</p>
            </div>

            <button
              type="submit"
              className="w-full py-[14px] mt-[18px] text-center text-white bg-[#26ae5f] rounded-[8px] flex items-center justify-center gap-1 mb-[12px] md:mb-[16px]"
            >
              <p className="text-sm font-medium leading-[20px]">Login</p>
              {isLoading && <ClipLoader color={"white"} size={20} />}
            </button>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default Hero;
